"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var types_1 = require("@wix/social-groups-api/dist/src/types");
var WixStatics_1 = require("@wix/social-groups-api/dist/src/services/wixStatics/WixStatics");
var GroupSEOItemType_1 = require("./GroupSEOItemType");
function getGroupSEOItemType(routeParams) {
    if (routeParams.commentId) {
        return GroupSEOItemType_1.GroupSEOItemType.GROUPS_COMMENT;
    }
    var pages = {
        discussion: GroupSEOItemType_1.GroupSEOItemType.GROUPS_FEED,
        about: GroupSEOItemType_1.GroupSEOItemType.GROUPS_ABOUT,
        media: GroupSEOItemType_1.GroupSEOItemType.GROUPS_MEDIA,
        members: GroupSEOItemType_1.GroupSEOItemType.GROUPS_MEMBERS,
    };
    var currentPage = pages[routeParams.activeTab];
    if (routeParams.feedItemId) {
        return GroupSEOItemType_1.GroupSEOItemType.GROUPS_POST;
    }
    return currentPage;
}
exports.getGroupSEOItemType = getGroupSEOItemType;
function feedItemsWithPlainTextContent(srcFeedItems) {
    return srcFeedItems.map(feedItemWithPlainTextContent);
}
exports.feedItemsWithPlainTextContent = feedItemsWithPlainTextContent;
function getPlainPostBody(feedItem) {
    if (!feedItem.entity || !feedItem.entity.body) {
        return '';
    }
    return feedItem.entity.body.contentType === types_1.SocialApiTypes.ContentType.DRAFTJS
        ? draftJsStringToPlainText(feedItem.entity.body.content)
        : feedItem.entity.body.content;
}
function feedItemWithPlainTextContent(feedItem) {
    return tslib_1.__assign({}, feedItem, { entity: {
            body: getPlainPostBody(feedItem),
        } });
}
exports.feedItemWithPlainTextContent = feedItemWithPlainTextContent;
function feedItemImages(feedItem) {
    return (feedItem.attachments || []).filter(isImage).map(function (imgAttachment) { return (tslib_1.__assign({ url: WixStatics_1.WixStatics.imageUrl(imgAttachment.uri) }, imgAttachment.pixelDimensions)); });
}
exports.feedItemImages = feedItemImages;
function isImage(attachment) {
    return attachment.mediaType === types_1.SocialApiTypes.MediaType.IMAGE;
}
function draftJsStringToPlainText(draftJs) {
    try {
        var content = JSON.parse(draftJs);
        var texts = content.blocks.map(function (block) { return block.text; });
        return texts.join('\n').trim();
    }
    catch (e) {
        // console.error(e);
        return draftJs;
    }
}
//# sourceMappingURL=utils.js.map